module.exports = __webpack_public_path__ + "static/img/slider-6.998c7f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/slider-6.jpg
// module id = ZHnC
// module chunks = 7